export default "__VITE_ASSET__9xQ46QBY__"